import { Location } from 'history';
import State from '../core/State';
import produce, { Draft } from 'immer';

const setLocation = (location: Location) =>
  produce((draft: Draft<State>) => {
    draft.location.pathname = location.pathname;
    draft.location.search = location.search;
  });

export default setLocation;
